/* eslint-disable max-lines */

/**
 * Auth Module
 */
import cloneDeep from "lodash/cloneDeep";
import isEqual from "lodash/isEqual";
import Nprogress from "nprogress";
import VueNotifications from "vue-notifications";
import apiFactory from "@/helpers/api";
import { userAPI } from "@/api";

const { post: postUserAPI, del: deleteUserAPI, get: getUserAPI, } = apiFactory();

function getFreshState() {
	return {
		settings: {
			notifications: {
				email_recap: true,
				email_planner: true,
				email_team: true,
			},
			scheduleFilters: {
				showAllDayEvents: true,
				showHiddenMeetings: false,
				showEventsWithOnlyMe: true,
			},
		},
	};
}

const cache = {};

const _state = getFreshState();
let _unobservableState = {};

function refreshUnobservableState() {
	_unobservableState = {};
}

function ustate( key, value ) {
	if ( value === undefined ) {
		return _unobservableState[ key ];
	}
	_unobservableState[ key ] = value;
}

// getters
const getters = {
	/**
	 * @deprecated - left for legacy reasons; see src/store/modules/planner/index.js
	 */
	settings: state => {
		return state.settings;
	},
};

// actions
const actions = {
	async getSettings( context ) {
		try {
			if ( ustate( "settings" ) ) {
				return;
			}

			ustate( "settings", 1 );
			Nprogress.start();
			const res = await getUserAPI( "/user/me/settings" );
			context.commit( "settingsLoaded", res );
		} catch ( e ) {
			VueNotifications.error( {
				message: e.message || e || "Unexpected error",
			} );
			console.error( e );
		}
		ustate( "settings", 0 );
		Nprogress.done();
	},
	async setSettings( context, settings ) {
		try {
			if ( ustate( "settings2" ) ) {
				return;
			}

			ustate( "settings2", 1 );
			Nprogress.start();
			await postUserAPI( "/user/me/settings", settings );
			context.commit( "settingsLoaded", settings );
		} catch ( e ) {
			VueNotifications.error( {
				message: e.message || e || "Unexpected error",
			} );
			console.error( e );
		}
		ustate( "settings2", 0 );
		Nprogress.done();
	},
	/**
	 * @deprecated unused, but leaving for reference
	 * @see UserSettings.vue
	 */
	async deleteAccount( context, { reason, comment, } ) {
		try {
			if ( ustate( "delete-account" ) ) {
				return;
			}
			ustate( "delete-account", 1 );
			Nprogress.start();
			await deleteUserAPI( "/user/me", { reason, comment, } );
			context.dispatch( "auth/logoutUser" );
		} catch ( e ) {
			VueNotifications.error( { message: e.message || e || "Unexpected error", } );
			console.error( e );
		}
		ustate( "delete-account", 0 );
		Nprogress.done();
	},
	async updatePersistentScheduleFilter( { commit, state, }, key ) {
		const scheduleFilters = cloneDeep( state.settings.scheduleFilters );
		scheduleFilters[ key ] = !scheduleFilters[ key ];
		if ( !isEqual( state.settings.scheduleFilters, scheduleFilters ) ) {
			await userAPI.saveUserSettings( { scheduleFilters, } );
		}
		commit( "setScheduleFilter", scheduleFilters );
	},
};

// mutations
const mutations = {
	logoutUser( state ) {
		const fresh = getFreshState();
		for ( const k of Object.keys( fresh ) ) {
			state[ k ] = fresh[ k ];
		}
		refreshUnobservableState();
		for ( const key of Object.keys( cache ) ) {
			cache[ key ] = {};
		}
	},
	settingsLoaded( state, value ) {
		state.settings = {
			notifications: value.notifications || JSON.parse( JSON.stringify( state.settings.notifications ) ),
			notificationTypes: value.notificationTypes || state.settings.notificationTypes,
			notificationDeliveryTypes: value.notificationDeliveryTypes || state.settings.notificationDeliveryTypes,
			scheduleFilters: value.scheduleFilters || state.settings.scheduleFilters,
		};
	},
	setScheduleFilter( state, scheduleFilters ) {
		state.settings = {
			...state.settings,
			scheduleFilters,
		};
	},
};

export default {
	state: _state,
	getters,
	actions,
	mutations,
};
/* eslint-enable max-lines */



// WEBPACK FOOTER //
// ./src/store/modules/api/index.js